<script lang="ts" setup>
import { computed, onMounted, useRoute } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import HTInputPhone from '~/components/HTInputPhone.vue';
import HTInputVerifyCode from '~/components/HTInputVerifyCode.vue';
import { LoginService } from '~/services/login.service';
import DedicatedPhoneTip from './DedicatedPhoneTip.vue';

const route = useRoute();
const service = useService(LoginService);

// csp模拟考专用链接
const isDedicatedLink = computed(() => {
  return route.name === 'oj_contest_detail' && !!route.query.uid;
});

onMounted(() => {
  service.init();
});
</script>

<template>
  <a-form
    :ref="(el) => (service.verifycodeFormRef = el)"
    class="hetao-form"
    layout="vertical"
    :model="service.model"
    :rules="service.rules"
    @finish="service.handleLoginByVerifyCode"
    @validate="service.handleOnValidate"
  >
    <DedicatedPhoneTip v-if="isDedicatedLink" class="-mt-4 mb-2.5" />
    <a-form-item
      name="phoneNumber"
      :validate-status="service.validModelStatus.phoneNumber"
    >
      <HTInputPhone
        v-model:short="service.model.short"
        v-model:code="service.model.countryCode"
        v-model:value="service.model.phoneNumber"
        v-model:pattern="service.phoneNumberPattern"
        :maxlength="11"
        placeholder="请输入手机号"
        autocomplete="tel"
        :allow-clear="true"
        size="large"
      />
      <template #help>
        <div
          v-if="service.validModelHelp.phoneNumber"
          class="flex h-6 justify-start"
        >
          <ExclamationCircleFilled class="mr-1" />
          <span>{{ service.validModelHelp.phoneNumber }}</span>
        </div>
        <div v-else class="h-6"></div>
      </template>
    </a-form-item>

    <a-form-item
      name="verifyCode"
      :validate-status="service.validModelStatus.verifyCode"
    >
      <HTInputVerifyCode
        v-model:value="service.model.verifyCode"
        autocomplete="one-time-code"
        placeholder="请输入验证码"
        :maxlength="6"
        :countdown="service.countdownSecond"
        :verify-code-disabled="!service.validModel.phoneNumber"
        size="large"
        @send-verify-code="service.handleSendVerifyCode"
      />
      <template #help>
        <div
          v-if="service.validModelHelp.verifyCode"
          class="flex h-6 justify-start"
        >
          <ExclamationCircleFilled class="mr-1" />
          <span>{{ service.validModelHelp.verifyCode }}</span>
        </div>
        <div v-else class="h-6"></div>
      </template>
    </a-form-item>

    <a-form-item>
      <a-button
        type="primary"
        class="disabled-opacity !text-sm !font-bold"
        block
        html-type="submit"
        size="large"
        :loading="service.loading"
        :disabled="service.formDisabled"
      >
        登录/注册
      </a-button>
    </a-form-item>
  </a-form>
</template>
